import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ChangeDetectionStrategy, Component} from "@angular/core";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

const debug = initDebugger('LasterDataKomponent');


/** Viser laste-indikator.
 * Bruk:
 * `<laster-data> vent mens vi laster data </laster-data>`
 */
@Component({
    selector: 'laster-data',
    templateUrl: './laster-data.html',
    styleUrls: ['./laster-data.scss'],
    imports: [
        MatProgressSpinnerModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LasterDataKomponent {

    constructor() {
    }

}

